import { render, staticRenderFns } from "./ProductCardInfo.vue?vue&type=template&id=fbbd0c20&"
import script from "./ProductCardInfo.vue?vue&type=script&lang=js&"
export * from "./ProductCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports